export default __webpack_public_path__ + "a0b2fd5a167098cdbdac8619ae3d0002.png";